import $ from 'jquery';
import Swiper from 'swiper';
export default class IndexPage {

    public init() {
        //console.log(this);
        this.initSlideBanner();
        this.initSlideLecturer();
        this.initSlideOrgani();
    }

    public initSlideBanner() {
        const sliderBanner: any = new Swiper('.slide-banner', {
            autoplay: true,
            pagination: {
                el: '.swiper-pagination',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        })
    }

    public initSlideLecturer() {
        const slideLecturer: any = new Swiper('.slide-lecturer',{
            autoplay: false,
            slidesPerView:5,
            spaceBetween:20,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        })
    }

    public initSlideOrgani() {
        const sliderOrgani: any = new Swiper('.slide-organi-list', {
            autoplay: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
        })
    }

}
